module.exports = __webpack_public_path__ + "img/art.fd276b53.png";